import {Lang} from './Lang';

export class Setting {
	public currentLanguage: Lang = new Lang('en', '', 'English');
	public languageList: Lang[] = [
		new Lang('en', '', 'English'),
		new Lang('fr', '', 'Français'),
		new Lang('it', '', 'Italiano'),
		new Lang('de', '', 'Deutsch'),
		new Lang('es', '', 'Español')
	];
	public email: string = '';
	public newPassword: string = '';
	public onlyOneMailADay: boolean = true;
	public sendMailForNewMessage: boolean = false;

	public setLang(shortCode: string) {
		this.currentLanguage = this.languageList.find(l => l.shortCode === shortCode) ?? this.languageList[0];
		return this;
	}
}
